import React, { useState } from 'react';
import './Subscribe.css';
import { useTranslation } from 'react-i18next';

function Subscribe() {
  const [email, setEmail] = useState('');
  const [isAgreed, setIsAgreed] = useState(false); // كائن حالة جديد للـ Checkbox
  const { t } = useTranslation();

  async function subscribe(ev) {
    ev.preventDefault();

    if (!email) {
      alert('يرجى إدخال البريد الإلكتروني!');
      return;
    }

    if (!isAgreed) {
      alert('يرجى الموافقة على الشروط والأحكام للاشتراك!');
      return;
    }

    const data = { email };

    try {
      const response = await fetch('https://www.albarede.com/server/subscriber.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        alert('تم الاشتراك بنجاح!');
        setEmail(''); 
        setIsAgreed(false); // إعادة تعيين الـ Checkbox بعد النجاح
      } else {
        const error = await response.json();
        alert(`خطأ: ${error.error || 'حدث خطأ ما'}`);
        console.error('Error creating subscriber:', error);
      }
    } catch (err) {
      console.error('Error creating subscriber:', err);
      alert('فشل في إرسال الطلب.');
    }
  }

  return (
    <div className='containerNew' data-aos='fade-up'>
      <div className='subsBox'>
        
        {/* القسم الأيمن: النصوص الترحيبية */}
        <div className='subsText-section'>
          <h3>{t('joinUs')}</h3>
          <p>{t('joinUsDisc')}</p>
        </div>
        
        {/* القسم الأيسر: الفورم المطور */}
        <form className='subsForm' onSubmit={subscribe}>
          
          {/* مجموعة حقل الإدخال الذكي مع Floating Label */}
          <div className="input-group-floating">
            <input
              type='email'
              value={email}
              id="subs-email-input"
              placeholder=" " /* ترك مسافة فارغة هنا ضروري جداً لعمل الـ CSS بنجاح */
              onChange={(ev) => setEmail(ev.target.value)}
              required
            />
            <label htmlFor="subs-email-input">{t('email')}</label>
          </div>
          
          {/* قسم التفاعل السفلي: تشيك بوكس المطور وزر الإرسال */}
          <div className='subsForm-footer'>
            <label className="premium-checkbox-container">
              <input 
                type='checkbox' 
                checked={isAgreed}
                onChange={(ev) => setIsAgreed(ev.target.checked)}
              />
              <span className="custom-checkmark"></span>
              <span className="checkbox-text">أوافق على الشروط والأحكام.</span>
            </label>
            
            <button className='subsBtn' type='submit'>
              {t('subsBtn')}
            </button>
          </div>

        </form>
      </div>
    </div>
  );
}

export default Subscribe;